export const userStorageKeys = {
  all: '/user_storage_items',
} as const;
